'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.Pagination');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.Pagination');

var _Content2 = _interopRequireDefault(_Content);

var _Button = require('./components/Button.Pagination');

var _Button2 = _interopRequireDefault(_Button);

var _fillArrayWithNumbers = require('./libs/fillArrayWithNumbers');

var _fillArrayWithNumbers2 = _interopRequireDefault(_fillArrayWithNumbers);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.isFirst = function () {
      return _this.props.page === 1;
    }, _this.isLast = function () {
      return _this.props.page === _this.props.pages;
    }, _this.onChange = function (page) {
      var _this$props = _this.props,
          pages = _this$props.pages,
          onChange = _this$props.onChange;
      if (page < 1 || page > pages || page === _this.props.page) return;
      onChange(page);
    }, _this.getPages = function () {
      var _this$props2 = _this.props,
          page = _this$props2.page,
          pages = _this$props2.pages;
      if (pages === 0) return (0, _fillArrayWithNumbers2.default)(1, 1);
      if (pages <= 5) return (0, _fillArrayWithNumbers2.default)(1, pages);
      if (page <= 3) return (0, _fillArrayWithNumbers2.default)(1, 5);
      if (pages - 2 <= page) return (0, _fillArrayWithNumbers2.default)(pages - 4, pages);
      return (0, _fillArrayWithNumbers2.default)(page - 2, page + 2);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pagination, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          page = _props.page,
          pages = _props.pages,
          small = _props.small,
          simple = _props.simple;
      return _react2.default.createElement(_Container2.default, null, !simple && _react2.default.createElement(_Button2.default, {
        icon: 'doubleleft',
        disabled: this.isFirst(),
        onClick: function onClick(e) {
          return _this2.onChange(1);
        },
        small: small
      }), _react2.default.createElement(_Button2.default, {
        icon: 'left',
        disabled: this.isFirst(),
        onClick: function onClick(e) {
          return _this2.onChange(page - 1);
        },
        small: small
      }), _react2.default.createElement(_Content2.default, {
        small: small,
        simple: simple
      }, simple ? page + ' / ' + pages : this.getPages().map(function (p) {
        return _react2.default.createElement(_Button2.default, {
          key: p,
          page: p,
          selected: page === p,
          small: small,
          onClick: function onClick(e) {
            return _this2.onChange(p);
          }
        });
      })), _react2.default.createElement(_Button2.default, {
        icon: 'right',
        disabled: this.isLast(),
        onClick: function onClick(e) {
          return _this2.onChange(page + 1);
        },
        small: small
      }), !simple && _react2.default.createElement(_Button2.default, {
        icon: 'doubleright',
        disabled: this.isLast(),
        onClick: function onClick(e) {
          return _this2.onChange(pages);
        },
        small: small
      }));
    }
  }]);

  return Pagination;
}(_react.Component);

Pagination.propTypes = {
  pages: _propTypes2.default.number.isRequired,
  page: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  small: _propTypes2.default.bool,
  simple: _propTypes2.default.bool
};
Pagination.defaultProps = {
  small: false,
  simple: false
};
exports.default = Pagination;